module.exports = __webpack_public_path__ + "img/mono-rounded.07caaa59.svg";